/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
import { useState, useEffect } from "react";
import { apiGetAllAvailableFlavors, apiGetCartItems } from "Root/api/apiCheckout";
export const useFlavors = ({ error_message, addonAttributes, setAddonAttributes }) => {
    const [proteinFlavors, setProteinFlavors] = useState([]);
    const [hydrationFlavors, setHydrationFlavors] = useState([]);
    const [preworkoutFlavors, setPreworkoutFlavors] = useState([]);
    const [flavorLimits, setFlavorLimits] = useState({});
    const [personalizedProducts, setPersonalizedProducts] = useState([]);
    const [performanceBoosts, setPerformanceBoosts] = useState([]);
    const [accessories, setAccessories] = useState([]);
    const [chooseProteinFlavorsScreen, setChooseProteinFlavorsScreen] = useState(true);
    const [choosePreworkoutFlavorsScreen, setChoosePreworkoutFlavorsScreen] = useState(true);
    const [chooseHydrationFlavorsScreen, setChooseHydrationFlavorsScreen] = useState(true);
    const [loading, setLoading] = useState(false);
    const [greensFlavors, setGreensFlavors] = useState([]);
    useEffect(() => {
        const getAllAvailableFlavors = async () => {
            const data = await apiGetAllAvailableFlavors();
            if (data) {
                // mock data
                const newProteinFlavors = data["protein-flavors"].map((item) => ({
                    ...item,
                    team_favorite: item.short_name === "peanut" || item.short_name === "strawberry",
                }));
                const newPWFlavors = data["preworkout-flavors"].map((item) => ({
                    ...item,
                    best_seller: item.short_name === "strawberry",
                }));
                setProteinFlavors(newProteinFlavors);
                setPreworkoutFlavors(newPWFlavors);
                setHydrationFlavors(data["hydration-flavors"]);
                setGreensFlavors(data["greens-flavors"]);
                setFlavorLimits({
                    protein: data["protein-limit"],
                    preworkout: data["preworkout-limit"],
                    hydration: data["hydration-limit"],
                    greens: 1,
                });
            }
        };
        getAllAvailableFlavors();
        const getCartItems = async () => {
            setLoading(true);
            const data = await apiGetCartItems();
            setLoading(false);
            if (data) {
                let personalizedTemp = [];
                const performanceTemp = [];
                const accessoriesTemp = [];
                const localAttributes = {};
                data.forEach((item) => {
                    if (item.item_category === "personalized") {
                        personalizedTemp.push(item);
                        if (item.attribute_toggles.length > 0) {
                            localAttributes[item.item_type] = item.attribute_toggles;
                        }
                    }
                    if (item.item_category === "performance_boosts") {
                        performanceTemp.push(item);
                    }
                    if (item.item_category === "accessories") {
                        accessoriesTemp.push(item);
                    }
                    if (item.item_category === "greens") {
                        // make sure greens are at the beginning of the array
                        personalizedTemp = [item, ...personalizedTemp];
                    }
                });
                setAddonAttributes(localAttributes);
                setPersonalizedProducts(personalizedTemp);
                setPerformanceBoosts(performanceTemp);
                setAccessories(accessoriesTemp);
            }
        };
        getCartItems();
    }, []);
    function updateAttribute(index, bool, product) {
        const addonAttributeCopy = JSON.parse(JSON.stringify(addonAttributes));
        addonAttributeCopy[product][index].attribute_on = bool;
        if (product === "preworkout") {
            // both cannot be false
            if (!addonAttributeCopy[product][0].attribute_on && !addonAttributeCopy[product][1].attribute_on) {
                error_message("Gainful does not offer this Pre-Workout Formula at this time");
                return;
            }
        }
        setAddonAttributes(addonAttributeCopy);
    }
    function addFlavor(event, shortname, flavorCounts, useCounter, maxFlavors, product) {
        product === "preworkout" && setChoosePreworkoutFlavorsScreen(true);
        product === "hydration" && setChooseHydrationFlavorsScreen(true);
        const locX = event.nativeEvent.offsetX;
        const width = event.nativeEvent.target?.offsetWidth;
        const count = flavorCounts[shortname];
        const flavorCountsCopy = { ...flavorCounts };
        let increment = 1;
        if (useCounter) {
            if (count > 0 && maxFlavors === 1) {
                if (locX < width / 2) {
                    increment = -1;
                }
            }
        }
        else if (count === 1) {
            increment = -1;
        }
        if (increment > 0) {
            if (maxFlavors > 1) {
                let currentTotal = 0;
                const keys = Object.keys(flavorCountsCopy);
                keys.forEach((key) => (currentTotal += flavorCountsCopy[key]));
                if (currentTotal >= maxFlavors) {
                    error_message("You've reached your limit of flavors");
                    return;
                }
            }
            else {
                const keys = Object.keys(flavorCountsCopy);
                keys.forEach((key) => (flavorCountsCopy[key] = 0));
                // for (const key in flavorCountsCopy) {
                //   flavorCountsCopy[key] = 0;
                // }
            }
        }
        const newcount = count + increment;
        flavorCountsCopy[shortname] = newcount;
        let newflav = [];
        if (product === "protein") {
            newflav = proteinFlavors.slice();
        }
        else if (product === "hydration") {
            newflav = hydrationFlavors.slice();
        }
        else if (product === "preworkout") {
            newflav = preworkoutFlavors.slice();
        }
        else if (product === "greens") {
            newflav = greensFlavors.slice();
        }
        newflav.forEach((flavInd, ind) => (newflav[ind].count = flavorCountsCopy[newflav[ind].short_name]));
        if (product === "protein") {
            setProteinFlavors(newflav);
        }
        else if (product === "hydration") {
            setHydrationFlavors(newflav);
        }
        else if (product === "preworkout") {
            setPreworkoutFlavors(newflav);
        }
        else if (product === "greens") {
            setGreensFlavors(newflav);
        }
    }
    function addProteinFlavor(shortname, flavorCounts, useCounter, maxFlavors, product, newcount) {
        const flavorCountsCopy = { ...flavorCounts };
        // eslint-disable-next-line max-len
        const totalChosen = proteinFlavors.reduce((totalcount, item) => (item.count ? (totalcount += item.count) : totalcount), 0);
        const isIncrement = newcount > flavorCountsCopy[shortname];
        if (isIncrement && totalChosen + 1 > maxFlavors) {
            error_message("You've reached your limit of flavors");
        }
        else {
            flavorCountsCopy[shortname] = newcount;
            setChooseProteinFlavorsScreen(true);
        }
        const newflav = proteinFlavors.slice();
        newflav.forEach((flavInd, ind) => (newflav[ind].count = flavorCountsCopy[newflav[ind].short_name]));
        setProteinFlavors(newflav);
    }
    return {
        addFlavor,
        addProteinFlavor,
        proteinFlavors,
        hydrationFlavors,
        preworkoutFlavors,
        flavorLimits,
        personalizedProducts,
        performanceBoosts,
        accessories,
        updateAttribute,
        chooseHydrationFlavorsScreen,
        choosePreworkoutFlavorsScreen,
        chooseProteinFlavorsScreen,
        setChooseHydrationFlavorsScreen,
        setChoosePreworkoutFlavorsScreen,
        setChooseProteinFlavorsScreen,
        loading,
        greensFlavors,
    };
};
export default useFlavors;
